import { Button, Modal } from "antd";
import React from "react";
import DOMPurify from 'dompurify';
import './calendar-descr.css';

const sanitizeHtml = (html) =>
  DOMPurify.sanitize(html, {
    USE_PROFILES: { html: true },
    FORBID_TAGS: ['a', 'object', 'iframe'],
  });

export const CalendarDescription = ({ ...props }) => {
  const { name, description, sotrName, sotrDescription, sotrImageUrl, onClose } = props;
  const descriptionHtml = description ? sanitizeHtml(description) : '';
  const sotrHtml = sotrDescription ? sanitizeHtml(sotrDescription) : '';
  const hasSotr = Boolean(sotrName || sotrImageUrl || sotrHtml);

  return (
    <Modal
      forceRender
      open
      onCancel={onClose}
      title={name}
      closeOnOutsideClick
      closable={false}
      onOk={onClose}
      footer={null}
    >
      {hasSotr && (
        <div className="cal-desc-sotr">
          {sotrImageUrl ? (
            <img className="cal-desc-sotr-photo" src={sotrImageUrl} alt={sotrName || ''} />
          ) : null}
          <div className="cal-desc-sotr-text">
            {sotrName ? <div className="cal-desc-sotr-name">{sotrName}</div> : null}
            {sotrHtml ? (
              <div
                className="cal-desc-sotr-html"
                dangerouslySetInnerHTML={{ __html: sotrHtml }}
              />
            ) : null}
          </div>
        </div>
      )}
      {descriptionHtml ? (
        <div
          className="cal-desc-product"
          dangerouslySetInnerHTML={{ __html: descriptionHtml }}
        />
      ) : null}
      <div className="cal-desc-buttons">
        <Button onClick={onClose} type="default">OK</Button>
      </div>
    </Modal>
  );
};
